export class UserPermission {
  constructor(data = {}, module = {}) {
    this.user_id = data['user_id'] || null;

    this.module_pbx_is_allowed = !!data['module_pbx_is_allowed'];
    this.module_hlr_is_allowed = !!data['module_hlr_is_allowed'];
    this.manage_trunks_is_allowed = !!data['manage_trunks_is_allowed'];
    this.module_autocaller_is_allowed = !!data['module_autocaller_is_allowed'];
    this.service_api_mailings_is_allowed = !!data['service_api_mailings_is_allowed'];
    this.service_calltracking_is_allowed = !!data['service_calltracking_is_allowed'];
    this.service_incoming_sms_is_allowed = !!data['service_incoming_sms_is_allowed'];
    this.service_database_export_is_allowed = !!data['service_database_export_is_allowed'];
    this.service_voice_detail_stats_export_is_allowed = !!data[
      'service_voice_detail_stats_export_is_allowed'
    ];
    this.service_mailing_detail_stats_export_is_allowed = !!data[
      'service_mailing_detail_stats_export_is_allowed'
    ];
    this.service_unmoderated_mailings_is_allowed = !!data[
      'service_unmoderated_mailings_is_allowed'
    ];
    this.service_unmoderated_senders_is_allowed = !!data['service_unmoderated_senders_is_allowed'];
    this.module_predictive_is_allowed = !!data['module_predictive_is_allowed'];
    this.module_predictive_is_disabled =
      data['module_predictive_is_allowed'] === 0 && module['predictive'].init === false;
  }
}
